/* ---------------------------------------------------------------------- */
/* ثابت‌های مشترک گزارش‌ساز                                                */
/* ---------------------------------------------------------------------- */

export const ELEMENT_TYPES = {
  TEXT: 'text',
  IMAGE: 'image',
  CHART: 'chart',
  RECTANGLE: 'rectangle',
  LINE: 'line',
  TABLE: 'table',
  DATA: 'data',
  // مقدار یک فیلد از رکورد جاری — فقط از تب «دیتا» ساخته می‌شود (نه از جعبه ابزار)
  FIELD: 'field',
};

export const TOOLBOX_ITEMS = [
  { type: ELEMENT_TYPES.TEXT, label: 'متن', icon: '🔤' },
  { type: ELEMENT_TYPES.IMAGE, label: 'تصویر', icon: '🖼️' },
  { type: ELEMENT_TYPES.CHART, label: 'نمودار', icon: '📊' },
  // { type: ELEMENT_TYPES.TABLE, label: 'جدول داده', icon: '📋' },
  { type: ELEMENT_TYPES.DATA, label: 'دیتا', icon: '🗄️' },
  { type: ELEMENT_TYPES.RECTANGLE, label: 'مستطیل', icon: '▭' },
  { type: ELEMENT_TYPES.LINE, label: 'خط', icon: '➖' },
];

export const DEFAULT_SIZE = {
  [ELEMENT_TYPES.TEXT]: { width: 160, height: 30 },
  [ELEMENT_TYPES.IMAGE]: { width: 120, height: 90 },
  [ELEMENT_TYPES.CHART]: { width: 320, height: 220 },
  [ELEMENT_TYPES.TABLE]: { width: 660, height: 240 },
  [ELEMENT_TYPES.RECTANGLE]: { width: 120, height: 70 },
  [ELEMENT_TYPES.LINE]: { width: 160, height: 2 },
  [ELEMENT_TYPES.DATA]: { width: 420, height: 220 },
  [ELEMENT_TYPES.FIELD]: { width: 140, height: 26 },
};

export const DEFAULT_PROPS = {
  [ELEMENT_TYPES.TEXT]: { content: 'متن نمونه', fontSize: 14, fontWeight: 'normal', color: '#1f2937', align: 'right' },
  [ELEMENT_TYPES.IMAGE]: { src: '', alt: '', repeatMode: 'all', onceIndex: 1 },
  [ELEMENT_TYPES.CHART]: { chartKey: '', repeatMode: 'all', onceIndex: 1 },
  [ELEMENT_TYPES.TABLE]: {
    rowHeight: 30,
    columns: [
      { id: 'c1', field: 'index', label: 'ردیف', width: 60 },
      { id: 'c2', field: 'name', label: 'شرح کالا', width: 280 },
      { id: 'c3', field: 'qty', label: 'تعداد', width: 100 },
      { id: 'c4', field: 'amount', label: 'مبلغ', width: 140 },
    ],
    rows: [],
  },
  [ELEMENT_TYPES.RECTANGLE]: { fill: '#e5e7eb', borderColor: '#9ca3af' },
  [ELEMENT_TYPES.LINE]: { color: '#9ca3af' },
  [ELEMENT_TYPES.DATA]: {
    dataSourceId: '',
    dataSourceName: '',
    displayMode: 'table', // 'table' | 'fields'
    rowHeight: 28,
    columns: [],
    rows: [],
    fields: [],
    filters: [],
    externalValues: {},
    // چاپ در صفحات جداگانه، بعد از پایان چاپ سایر موارد (جدول یا fields)
    printSeparately: false,
    // فقط برای displayMode === 'fields':
    // 'perPage'  -> هر رکورد یک صفحه‌ی مجزا می‌شود
    // 'stacked'  -> کل بلوک دیتا (با همه‌ی آیتم‌های داخلش) پشت‌سرهم تا جایی که در صفحه جا می‌شود تکرار می‌شود
    fieldsRepeatMode: 'perPage',
  },
  [ELEMENT_TYPES.FIELD]: {
    dataElementId: '',
    field: '',
    label: '',
    showLabel: false,
    fontSize: 13,
    fontWeight: 'normal',
    color: '#1f2937',
    align: 'right',
  },
};

export const SECTION_LABELS = { header: 'هدر', detail: 'بدنه گزارش', footer: 'فوتر' };

export const ROW_STYLE = { width: '100%', display: 'flex', justifyContent: 'space-between', gap: '4px', marginBottom: 10, alignItems: 'center' };

export const PERSIST_ROWS = false;

// فیلترهای تعریف‌شده‌ی گزارش (در ریداکس: ReportBuilder.present.filters)
export const EMPTY_FILTERS = [];
export const EMPTY_OBJECT = {};
export const FILTER_TYPE_LABELS = { 1: 'Select', 2: 'Multi Select', 3: 'Radio', 4: 'List', 5: 'Date' };

export const FILTER_OPERATORS = [
  { value: 'eq', label: 'برابر باشد با' },
  { value: 'neq', label: 'برابر نباشد با' },
  { value: 'contains', label: 'شامل باشد' },
  { value: 'gt', label: 'بزرگتر از' },
  { value: 'lt', label: 'کوچکتر از' },
];

// FontPicker به format.decimal دسترسی دارد؛ پس هیچ‌وقت نباید undefined بگیرد
export const DEFAULT_FONT_FORMAT = { decimal: 0 };

export const ALIGN_TO_JUSTIFY = { right: 'flex-start', left: 'flex-end', center: 'center', justify: 'flex-start' };

// هر بار چند صفحه به پیش‌نمایش اضافه شود
export const PAGE_BATCH = 3;
